import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { baseConfig } from "@purple-dot/translations";
import allLocales from "@purple-dot/translations/locales/all";
import i18next from "i18next";
import { useEffect } from "react";
import { initReactI18next, useTranslation as reactUseTranslation } from "react-i18next";
// Configure i18next with all supported locales and namespaces used in the frontend.
// We just import all the JSON and shove it into i18next. This is suboptimal for performance
// because e.g. the checkout now has to load language it isn't actually rendering.
if (i18next.isInitialized) {
    void i18next.use(initReactI18next).init();
} else {
    i18next.use(initReactI18next).init(_object_spread_props(_object_spread({}, baseConfig), {
        initImmediate: false,
        resources: allLocales,
        ns: [
            "translation",
            "countries"
        ]
    }))// biome-ignore lint/suspicious/noConsole: log
    .catch(function(err) {
        return console.error(err);
    });
}
export function useTranslation(ns, opts) {
    var res = reactUseTranslation(ns !== null && ns !== void 0 ? ns : "translation", opts);
    useEffect(function() {
        var queryParamLocale = new URLSearchParams(window.location.search).get("locale");
        var passedInLocale = opts === null || opts === void 0 ? void 0 : opts.locale;
        var locale = passedInLocale || queryParamLocale || window.navigator.language;
        if (locale) {
            // biome-ignore lint/suspicious/noConsole: old
            res.i18n.changeLanguage(locale).catch(function(err) {
                return console.error(err);
            });
        }
    }, []);
    var currentLocale = res.i18n.resolvedLanguage;
    return _object_spread_props(_object_spread({}, res), {
        currentLocale: currentLocale
    });
}
